module.exports = __webpack_public_path__ + "img/tech_9.7212ef28.png";